module.exports = __webpack_public_path__ + "img/adviceInProgress.5bca002a.svg";